import { Stack as NbStack } from 'native-base';

import { addWithConfig } from '../../utils';

export const Stack = NbStack;

export default addWithConfig(Stack);
